import React from 'react';
import { Search } from 'lucide-react';

interface FacilitiesSearchFilterProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  resultsCount: number;
  totalCount: number;
}

const FacilitiesSearchFilter: React.FC<FacilitiesSearchFilterProps> = ({
  searchQuery,
  setSearchQuery,
  resultsCount,
  totalCount,
}) => {
  const handleClear = () => {
    setSearchQuery('');
  };

  return (
    <div className="mb-6">
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          <Search className="h-5 w-5 text-gray-400" aria-hidden="true" />
        </div>

        <input
          type="text"
          id="searchFacilities"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Filter results by any field..."
          className="block w-full rounded-lg border border-gray-300 dark:border-gray-700 py-2 pl-10 pr-20 text-gray-900 focus:border-[rgb(227,66,144)] focus:ring-[rgb(227,66,144)] dark:bg-gray-800 dark:text-white dark:placeholder:text-gray-400 sm:text-sm"
        />

        {searchQuery && (
          <button
            onClick={handleClear}
            className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-500"
          >
            <span className="text-sm font-medium">Clear</span>
          </button>
        )}
      </div>

      {searchQuery && (
        <div className="mt-2 flex items-center text-sm text-gray-500 dark:text-gray-400">
          <span>
            Showing <span className="font-medium">{resultsCount}</span> of{' '}
            <span className="font-medium">{totalCount}</span> facilities
          </span>
        </div>
      )}
    </div>
  );
};

export default FacilitiesSearchFilter;
